var _path, _path2, _path3, _path4, _rect, _path5, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTsvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.308 13.951C16.5594 13.9101 16.6801 13.7485 16.5568 13.6179L13.2548 10.1229C13.1635 10.0262 12.9652 9.97879 12.779 10.0091L12.5337 10.049C12.2823 10.0899 12.1615 10.2515 12.2848 10.3821L15.5868 13.8771C15.6782 13.9738 15.8764 14.0212 16.0626 13.9909L16.308 13.951Z",
    fill: "#D6D6E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2561 13.8261C12.0138 13.7703 11.9242 13.6022 12.0714 13.4799L16.013 10.204C16.122 10.1134 16.3281 10.0782 16.5075 10.1195L16.7439 10.174C16.9862 10.2298 17.0758 10.3978 16.9286 10.5202L12.987 13.7961C12.878 13.8867 12.6719 13.9219 12.4925 13.8806L12.2561 13.8261Z",
    fill: "#D6D6E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.308 13.951C16.5594 13.9101 16.6801 13.7485 16.5568 13.6179L13.2548 10.1229C13.1635 10.0262 12.9652 9.97879 12.779 10.0091L12.5337 10.049C12.2823 10.0899 12.1615 10.2515 12.2848 10.3821L15.5868 13.8771C15.6782 13.9738 15.8764 14.0212 16.0626 13.9909L16.308 13.951Z",
    stroke: "#D6D6E0",
    strokeWidth: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2561 13.8261C12.0138 13.7703 11.9242 13.6022 12.0714 13.4799L16.013 10.204C16.122 10.1134 16.3281 10.0782 16.5075 10.1195L16.7439 10.174C16.9862 10.2298 17.0758 10.3978 16.9286 10.5202L12.987 13.7961C12.878 13.8867 12.6719 13.9219 12.4925 13.8806L12.2561 13.8261Z",
    stroke: "#D6D6E0",
    strokeWidth: 0.75
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 12.2354,
    width: 10,
    height: 0.764706,
    rx: 0.382353,
    fill: "#D6D6E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.98905 11.4705C4.49236 11.4705 4.13285 10.9964 4.26687 10.5182L6.84654 1.31228C6.93728 0.988477 7.23245 0.764648 7.56872 0.764648H8.01095C8.50764 0.764648 8.86715 1.23874 8.73313 1.71702L6.15346 10.9229C6.06272 11.2467 5.76755 11.4705 5.43128 11.4705H4.98905Z",
    fill: "#D6D6E0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 12,
    height: 1.52941,
    rx: 0.764706,
    fill: "#D6D6E0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTsvg);
export default __webpack_public_path__ + "static/media/tsvg.3287ee6f358351029046b9e1dd3b5be6.svg";
export { ForwardRef as ReactComponent };